/*
    创建者：shuxiaokai
    创建时间：2020-04-30 08:34
    模块名称：可拖拽卡片
    备注：xxxx
*/
<template>
    <div v-show="isShow" ref="s-drag" class="s-drag-card" :class="{ 'not-allowed': !canDrop }" :style="{ left: left + 'px', top: top + 'px' }">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        initLeft: { //距离左侧距离
            type: Number,
            default: 0,
        },
        initTop: { //距离顶部距离
            type: Number,
            default: 0
        },
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            width: 0, //宽度
            height: 0, //高度
            left: 0, //左侧距离
            top: 0, //顶部距离
            offsetLeft: 0, //拖拽时候抵消左侧距离，目的是为了让拖拽物体居中
            offsetTop: 0, //拖拽时候抵消顶部距离，目的是为了让拖拽物体居中
        };
    },
    computed: {
        canDrop() {
            const wrap = this.$store.state.widget.wrapConfig.boundingClientRect;
            const drop = this.$store.state.widget.widgetConf.boundingClientRect;
            if (drop.left < wrap.left) { //小于左侧距离
                return false;
            }
            if (drop.top < wrap.top) { //小于顶部距离
                return false;
            }
            if (drop.top + drop.height > wrap.top + wrap.height) { //超出底部
                return false;
            }
            if (drop.left + drop.width > wrap.width) {
                return false;
            }
            return true;
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.$nextTick(() => { //v-show延迟改变
                    this.init()
                });
            } 
        }
    },
    created() {

    },
    mounted() {
        document.documentElement.addEventListener("mouseup", (e) => {
            // e.stopPropagation();
            document.documentElement.removeEventListener("mousemove", this.handleMouseMove);
            this.handleDrop();
            this.$emit("update:isShow", false)
        })
    },
    methods: {
        //=====================================初始化====================================//
        init() {
            const dragDom = this.$refs["s-drag"];
            this.width = dragDom.getBoundingClientRect()["width"];
            this.height = dragDom.getBoundingClientRect()["height"];
            this.offsetLeft = this.width / 2;
            this.offsetTop = this.height / 2;
            this.left = this.initLeft - this.offsetLeft;
            this.top = this.initTop - this.offsetTop;
            document.documentElement.addEventListener("mousemove", this.handleMouseMove);
        },
        //处理鼠标移动
        handleMouseMove(e) {
            e.stopPropagation();
            this.left = e.clientX - this.offsetLeft;
            this.top = e.clientY - this.offsetTop;
            this.$emit("move", {
                left: this.left,
                top: this.top,
                width: this.width,
                height: this.height,
            });
        },
        //处理鼠标松开事件
        handleDrop() {
            this.$emit("mouseup", this.canDrop);
            this.$store.commit("resetDragWidgetBoundingCLientRect"); //重置防止连续点击创建widget
        },
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.s-drag-card {
    background: $white;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2020;
    &.not-allowed {
        cursor: not-allowed;
    }
    
}
</style>
